import { render, staticRenderFns } from "./CRM.vue?vue&type=template&id=03e564f4&scoped=true"
import script from "./CRM.vue?vue&type=script&lang=js"
export * from "./CRM.vue?vue&type=script&lang=js"
import style0 from "./CRM.vue?vue&type=style&index=0&id=03e564f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e564f4",
  null
  
)

export default component.exports